import mergeToNew from "@insite/client-framework/Common/mergeToNew";
import { cardContainerMultiColumnStyles } from "@insite/content-library/Components/CardContainerMultiColumn";
import { css } from "styled-components";

cardContainerMultiColumnStyles.gridItem = mergeToNew(cardContainerMultiColumnStyles.gridItem, {
    width: [12, 12, 4, 3, 3],
    css: css`
        padding: 0;
    `,
});

cardContainerMultiColumnStyles.cardDivider = mergeToNew(cardContainerMultiColumnStyles.cardDivider, {
    css: css`
        padding: 10px;
        height: 100%;
        width: 100%;
        overflow: hidden;
        border-bottom: 0;
    `,
});
